"use client";

import { Box } from "@mui/material";
import { AnimatePresence, motion, Variants } from "framer-motion";
import React from "react";

interface GradualSpacingProps {
    text: string;
    duration?: number;
    delayMultiple?: number;
    framerProps?: Variants;
    style?: React.HTMLAttributes<HTMLHeadElement>["style"];
}

export default function GradualSpacing({
    text,
    duration = 0.5,
    delayMultiple = 0.04,
    framerProps = {
        hidden: { opacity: 0, x: -20 },
        visible: { opacity: 1, x: 0 },
    },
    style
}: GradualSpacingProps) {
    return (
        <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
            <AnimatePresence>
                {text.split("").map((char, i) => (
                    <motion.h1
                        key={i}
                        initial="hidden"
                        animate="visible"
                        exit="hidden"
                        variants={framerProps}
                        transition={{ duration, delay: i * delayMultiple }}
                        style={style}
                    >
                        {char === " " ? <span>&nbsp;</span> : char}
                    </motion.h1>
                ))}
            </AnimatePresence>
        </Box>
    );
}